import React, { memo } from 'react';

import { LandingPageHeadlineProps } from './interfaces';

const Headline = ({ headline, subheadline }: LandingPageHeadlineProps): JSX.Element => {
  return (
    <header>
      <h1 className="md:headline-xl mb-0 mt-16 font-suisse-works text-headline-lg sm:mt-0">
        {headline}
      </h1>
      {subheadline && (
        <p className="mb-0 mt-8 font-suisse-neue text-subheadline-sm text-grayscale-gray md:text-subheadline-md">
          {subheadline}
        </p>
      )}
    </header>
  );
};

export default memo(Headline);
